<template>
  <hr :id="field.name">
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>




// WEBPACK FOOTER //
// DividerRender.vue?7b533cc9